module.exports = __webpack_public_path__ + "static/media/app2.8c8d2f7d.jpg";